<agr-form-dialog
  [formGroup]="formGroup"
  [data]="data"
  (cancel)="cancelEditFieldSettings()"
  (confirm)="confirmEditFieldSettings($event)"
  data-test="edit-field-settings"
>
  @if (!data.cropFields?.length) {
    <p data-test="no-fields-text">
      {{ 'fields.noFieldsFound' | translate }}
    </p>
  }

  @if (data.cropFields?.length) {
    <label class="search-field__assistive-label" for="field-search-input">
      {{ 'fields.searchFields' | translate }}
    </label>
    <mat-form-field class="search-field" appearance="outline">
      <mat-label>{{ 'fields.searchFields' | translate }}</mat-label>
      <input
        id="field-search-input"
        matInput
        [formControl]="searchControl"
        [placeholder]="'fields.searchFields' | translate"
        data-test="field-search-input"
      />
    </mat-form-field>
  }

  @if (data.cropFields?.length && !filteredCropFields.length) {
    <p data-test="no-filtered-fields-text">
      {{ 'fields.noSearchResults' | translate }}
    </p>
  }

  @for (field of filteredCropFields; track field.cropField.id; let first = $first) {
    <div data-test="field-row">
      @if (!first) {
        <div class="spacing--margin-bottom"><mat-divider></mat-divider></div>
      }
      <app-field-details
        [data]="data"
        [cropField]="field.cropField"
        [formGroup]="getFormGroup(field.index, manureSpaceSettings)"
        (formDataLoaded)="onFieldDataLoaded(field.index)"
      ></app-field-details>
    </div>
  }
</agr-form-dialog>
